import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Login } from '.';

export { AccountLayout };

function AccountLayout() {
    const auth = useSelector(x => x.auth.value);

    // redirect to Geolocalisation if already logged in
    if (auth) {
        <Navigate to="/"/>
    }

    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
}
